import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { Button as ButtonReactStrap } from "reactstrap";
import { AggregationCropWise } from "./AggregationCropWise";
import { AggregationDetailView } from "./AggregationDetailView";

export const AggregationParent = ({ crops, fpo_name }) => {
  const [detailView, setDetailView] = useState(false);
  const [aggrigationId, setaggrigationId] = useState("");
  const [aggrigationDetails, setaggrigationDetails] = useState("");

  return (
    <Card className="p-4">
      <div className="d-flex justify-content-end gap-2">
        {detailView && (
          <ButtonReactStrap
            id="AddLeads"
            className="primary"
            size="sm"
            onClick={() => setDetailView(false)}
          >
            Back&nbsp;
            <span className="mdi mdi-rotate-left fs-6"></span>
          </ButtonReactStrap>
        )}
      </div>

      {detailView ? (
        <AggregationDetailView
          aggrigationId={aggrigationId}
          setaggrigationId={setaggrigationId}
          aggrigationDetails={aggrigationDetails}
        />
      ) : (
        <AggregationCropWise
          crops={crops}
          setDetailView={setDetailView}
          detailView={detailView}
          aggrigationId={aggrigationId}
          setaggrigationId={setaggrigationId}
          setaggrigationDetails={setaggrigationDetails}
          fpo_name={fpo_name}
        />
      )}
    </Card>
  );
};
